<div
  ngbDropdown
  class="video-settings-container"
  [class.is-fullscreen]="isFullscreen"
  [autoClose]="'outside'"
  #dropdownRef="ngbDropdown"
  [container]="isFullscreen() ? null : 'body'"
  [placement]="'top'">
  <button type="button" class="btn viewer-controller-icon-btn btn-settings" aria-label="Settings" ngbDropdownToggle>
    <img ngSrc="/assets/svg/subsection/settings.svg" alt="Settings" width="18" height="19" />
    @if (has4KResolution()) {
      <span class="badge badge-4k">4K</span>
    }
  </button>

  @if (mode() === 'video') {
    <div ngbDropdownMenu class="viewer-settings-menu">
      @if (!activeOptionType()) {
        @for (optionType of optionTypes; track optionType) {
          <button
            type="button"
            class="btn btn-block d-flex align-items-center justify-content-between mt-0 btn-setting-item ps-1"
            [class.active]="optionType === activeOptionType()"
            ngbDropdownItem
            (click)="setOptionType(optionType)">
            <span>{{ optionType | translate }}</span>
            <div class="d-flex align-items-center text-muted">
              @if (optionType === SettingOptionType.PLAYBACK_RATE) {
                <span class="me-2">{{ playbackRateText() | translate }}</span>
              } @else {
                <span class="me-2">{{ resolutionText() }}</span>
              }
              <i class="fa fa-angle-right"></i>
            </div>
          </button>
        }
      } @else {
        <button
          type="button"
          class="btn btn-block d-flex align-items-center mt-0 btn-selected-option btn-setting-item ps-1"
          ngbDropdownItem
          (click)="setOptionType(null)">
          <i class="fa fa-angle-left me-2"></i>
          <span>{{ activeOptionType() | translate }}</span>
        </button>

        @switch (activeOptionType()) {
          @case (SettingOptionType.RESOLUTION) {
            @for (item of resolutions(); track item.res) {
              <button
                type="button"
                class="btn btn-block d-flex align-items-center mt-0 btn-setting-item ps-1"
                [class.active]="item.res === resolution()"
                ngbDropdownItem
                (click)="setResolution(item)">
                <i
                  class="d-inline-block me-2"
                  [class.fa]="item.res === resolution()"
                  [class.fa-check]="item.res === resolution()"></i>
                <span>{{ item.label }}</span>
                <div class="ms-auto resolution-info">
                  @switch (item.res) {
                    @case ('2160') {
                      <span class="badge me-2">4K</span>
                      <span class="desc">Ultra HD</span>
                    }
                    @case ('1080') {
                      <span class="badge me-2">HD</span>
                      <span class="desc">Full HD</span>
                    }
                    @case ('720') {
                      <span class="desc">HD</span>
                    }
                    @default {
                      <span class="desc">SD</span>
                    }
                  }
                </div>
              </button>
            }
          }
          @case (SettingOptionType.PLAYBACK_RATE) {
            @for (item of playbackRateItems; track item.value) {
              <button
                type="button"
                class="btn btn-block d-flex align-items-center mt-0 btn-setting-item ps-1"
                [class.active]="item.value === playbackRate()"
                ngbDropdownItem
                (click)="setPlaybackRate(item.value)">
                <i
                  class="d-inline-block me-2"
                  [class.fa]="item.value === playbackRate()"
                  [class.fa-check]="item.value === playbackRate()"></i>
                <span>{{ item.text }}</span>
              </button>
            }
          }
        }
      }
    </div>
  } @else if (mode() === 'audio') {
    <div ngbDropdownMenu class="viewer-settings-menu">
      @for (item of audioSpeedItems; track item.value) {
        <button
          type="button"
          class="btn btn-block d-flex align-items-center mt-0 btn-setting-item ps-1"
          [class.active]="item.value === playbackRate()"
          ngbDropdownItem
          (click)="setPlaybackRate(item.value)">
          <i
            class="d-inline-block me-2"
            [class.fa]="item.value === playbackRate()"
            [class.fa-check]="item.value === playbackRate()"></i>
          <span>{{ item.text }}</span>
        </button>
      }
    </div>
  }
</div>
